function Recent(container) {
  var sectionId = container.getAttribute('data-section-id'),
      limit = container.getAttribute('data-limit'),
      width = container.getAttribute('data-width'),
      size = container.getAttribute('data-size'),
      sizes = container.getAttribute('data-sizes');
  container.parentNode.style.height = container.parentNode.clientHeight + 'px';
  const pD = JSON.parse(localStorage.getItem('rVP'));
  const rVH = []
  if (pD) {    
    pD.slice(-Math.abs(limit)).forEach(function(item,i){
      rVH.push('id:' + item.pID);
    });    
    const rB = rVH.join('%20OR%20');    
    fetch(theme.routes_search_url + '?section_id=section-recent&q=' + rB + '&type=product')      
    .then(response => response.text())
    .then(data => {   
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(data, 'text/html');      
      var rVD = container.querySelector('.recently-viewed-section'),
          cP = htmlDocument.documentElement.querySelector('section'),
        slider = cP.getAttribute('data-slider')
          tbd = cP.querySelectorAll('.product'),
          tbdF = Array.from(tbd);
      container.querySelector('.recently-viewed-section').innerHTML = '';      
      container.parentNode.style.height = 'auto';
      for (let i = 0; i < tbd.length; i++) {
        var iD = JSON.parse(tbd[i].getAttribute('data-id'));
        tbd[i].setAttribute('data-index', pD.findIndex(e => e.pID === iD));
        tbd[i].classList.add(width);          
        tbd[i].querySelectorAll('img').forEach(function(i) {
          i.setAttribute('sizes', sizes);
        });
      }
      function comparator(a, b) {
        if (a.dataset.index < b.dataset.index) return 1;
        if (a.dataset.index > b.dataset.index) return -1;
        return 0;
      }
      let s = tbdF.sort(comparator);
      s.forEach(e => rVD.appendChild(e));
      if (pD.length >= limit) {
        var list_count = limit
      } else {
        var list_count = pD.length
        container.querySelector('.product-loop').classList.add('center');
        if (slider == 'true') {
          container.querySelector('.glider-pagination').classList.add('hidden');
        }
      }
      var Carousel = document.getElementById('glider-carousel-' + sectionId);
      if (Carousel) {
        Sliders(container);
      } else {        
        container.querySelector('.table-center').classList.remove('glider');
      }      
      if (theme.settings.quickView) {
        Quick();
      };
      if (theme.settings.compare) {
        CompareProducts();
      };
      Swatches(container);
      if (theme.settings.cart) {
        var sI = cP.getAttribute('data-section-id');
        Cart(container,sI);
      }
    }).catch(function (err) {
      console.log('!: ' + err);
    });
  } else {
    setTimeout(function() {
      container.parentNode.classList.add('empty');
      container.parentNode.style.height = '0px'
    }, 1);
  }
}

document.addEventListener('Section:Loaded', function(event){
  let sectionContainer = event.detail;
  let sectionType = sectionContainer.dataset.sectionType;
  if(sectionType === 'recent'){
    Recent(sectionContainer);
  }
})

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  if(sectionType === 'recent' && !sectionContainer.classList.contains('ignore')){
    Recent(sectionContainer);
    sectionContainer.classList.add('ignore');
  }
})